import { theme } from "../../utils/theme";

export const styles = {
  background: {
    left: { xs: "-120%", md: "-100%" },
    position: "absolute",
    top: { xs: "-8%", md: "-24%" },
    zIndex: -1,
  },
  productRoot: {
    alignItems: "center",
     backgroundColor: theme.palette.grays.white,
    color: theme.palette.grays.black,
    display: "flex",
    height: "100%",
    justifyContent: "center",
    position: "relative",
    width: "100%",
  },
};
